export default __webpack_public_path__ + "static/media/18_shop 2.0677d789.gif";